/* eslint-disable */
import Vue from 'vue';
import 'jquery.cookie';
import 'jcarousel';

import CountryConditions from '@ve/components/countryConditions/desktop/CountryConditions.vue';

import HotelsRepository from "@/js/common/Domain/Repository/Hotels";
import FilterCriteriaModel from "@/js/desktop/components/filterCriteria/FilterCriteriaModel";
import FilterCriteriaView from "@/js/desktop/components/filterCriteria/FilterCriteria";
import FixFiltersPositionView from "@/js/desktop/components/filterCriteria/FixFiltersPosition";
import SearchPageHotelView from "@/js/desktop/View/SearchPageHotel";
import searchSessionService from "@/js/common/Domain/Service/search/searchSession";
import HotelCategoriesRepository from "@/js/common/Domain/Repository/HotelCategories";
import MealsRepository from "@/js/common/Domain/Repository/Meals";
import gaAsync from "@/js/common/Domain/Service/gaAsync";
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import SystemInfoBenchmark from '@ve/services/SystemInfoBenchmark';
import SearchPageModel from "@/js/desktop/Domain/Model/SearchPageModel";
import MakeSearchStaticBannerView from "@/js/desktop/components/search/makeSearchStaticBanner/MakeSearchStaticBanner";
import FixMapPositionView from "@/js/desktop/components/search/fixMapPosition/FixMapPosition";

import HotelOnMapView from '@/js/desktop/components/hotelOnMap/hotelOnMap';
import getStore from '@ve/services/getStore/getStore';
import RefreshLoaderWrapper from '@ve/components/refreshLoader/desktop/RefreshLoaderWrapper.vue';

var hotelsCollection = new HotelsRepository();
var filterCriteria = new FilterCriteriaModel();

const SearchPageView = Backbone.Epoxy.View.extend({
	arrayCriterias:['operators'],
	collection: hotelsCollection,
	model: null,
	events: {
		'click .searchContainer_filtersButton': 'toggleFilters',
		'click .banner-close': 'closeBanner'
	},
	filtersUpdateTimeout:null,
	closeBanner(e) {
		const currentTarget = e.currentTarget;
		const banerName = $(currentTarget).data('banner');
		const bannerPosition = $(currentTarget).data('index') + 1;
		const parent = currentTarget.parentElement;

		if (!parent) return;

		window.dataLayer.push({
			event: 'selectContent',
			selectContent:
			{
				prop: [
					{ type: 'engageBanner', value: banerName }
				],
				prop2: [
					{ type: 'position', value: bannerPosition }
				]
			}
		});

		$(parent).remove();
	},
	toggleFilters:function(e) {
		this.filters.$el.toggleClass('filtersOpened');
	},
	setOtherCriterias:function(data) {
		var self = this,
			attributes = {},
			filterCriteria = this.model.get('filterCriteria'),
			filterCriteriaAttrbutes = filterCriteria.attributes,
			sid;

		if(data && data.sid) {
			searchSessionService.setSearchId(data.sid);
		} else {
			searchSessionService.generateNewSearchId();
		}

		if(!data) {
			return;
		}

		if(!data) {
			return;
		}

		if (data.sort && ~_.indexOf(['recommend', 'priceUp', 'priceDown', 'ratingDown', 'reviewsDown'], data.sort)) {
			this.model.set('sortStrategy', data.sort);
		}

		//load filters
		_.each(data, function(value, key) {
			var attribute = key.replace('f_', '');
			if(~self.arrayCriterias.indexOf(attribute) && attribute in filterCriteriaAttrbutes) {
				attributes[attribute] = _.map(value.split('.'), function(id) {
					var intId = parseInt(id, 10);
					return intId || null;
				});
			} else if(/^f_/.test(key) && attribute in filterCriteriaAttrbutes) {
				attributes[attribute] = value === "true" ? true : value;
			}
		});

		filterCriteria.set(attributes, {
			initiator: 'loadFromUrl'
		});
	},
	getOtherCriterias:function() {
		var self = this,
			otherCriteria = {
				sid: searchSessionService.getSearchId()
			},
			sortStrategy = this.model.get('sortStrategy'),
			filterCriteria = this.model.get('filterCriteria');

		if(sortStrategy) {
			otherCriteria.sort = sortStrategy;
		}

		if(filterCriteria) {
			filterCriteria = _.omit(this.model.get('filterCriteria').attributes, 'minPrice', 'maxPrice');

			_.each(filterCriteria, function(value, name) {
				if(~self.arrayCriterias.indexOf(name) && value.length) {
					otherCriteria['f_' + name] = value.join('.');
				} else if(value) {
					otherCriteria['f_' + name] = value;
				}
			});
		}

		return otherCriteria;
	},
	initSlider() {
        var $slider = $('#priceRangeSlider'),
            self = this,
            defaultMinPrice = self.model.get('defaultMinPrice'),
            defaultMaxPrice = self.model.get('defaultMaxPrice');

        $slider.slider({
            range: true,
            values: [defaultMinPrice, defaultMaxPrice],
            min: defaultMinPrice,
            max: defaultMaxPrice,
            disabled: false,
            slide(event, ui) {
                if (ui.values[0] > ui.values[1]) {
                    return false;
                }

                var minValue = self.model.get('minPrice'),
                    maxValue = self.model.get('maxPrice');

                if (ui.values[1] < minValue || ui.values[0] > maxValue) {
                    return false;
                }
                self.model.set('sliderMinPriceFormatted', ui.values[0]);
                self.model.set('sliderMaxPriceFormatted', ui.values[1]);
                return true;
            },
            change(e, ui) {
                var minValue = ui.values[0],
                    maxValue = ui.values[1],
                    unfilteredMinPrice = self.model.get('unfilteredMinPrice'),
                    unfilteredMaxPrice = self.model.get('unfilteredMaxPrice');

                if (e.currentTarget) {
                    self.filters.model.set('minPrice', minValue > unfilteredMinPrice ? minValue : defaultMinPrice);
                    self.filters.model.set('maxPrice', maxValue < unfilteredMaxPrice ? maxValue : defaultMaxPrice);
                    self.model.set('sliderMinPriceFormatted', ui.values[0]);
                    self.model.set('sliderMaxPriceFormatted', ui.values[1]);
                }
            }
        });
        $('.priceRangeFilter').on('blur', '.minPriceFilter', function() {
            const values = $slider.slider('values');
            values[0] = $(this).val();
            if (typeof values[0] == 'string') {
                values[0] = parseInt(values[0].split(' ').join(''))
            }
            values[0] = values[0] > 0 ? values[0] : 0;
            if (values[0] > values[1]) {
                values[0] = values[1];
            }
            $slider.slider('values', values);
        });
        $('.priceRangeFilter').on('blur', '.maxPriceFilter', function () {
            const values = $slider.slider('values');
            values[1] = $(this).val();
            if (typeof values[1] == 'string') {
                values[1] = parseInt(values[1].split(' ').join(''))
            }
            values[1] = values[1] > 0 ? values[1] : Infinity;
            if (values[1] < values[0]) {
                values[1] = values[0];
            }
            $slider.slider('values', values);
        });

        const formatterInput = (e) => {
            const rawValue = e.target.value;
            const formattedValue = typeof rawValue === 'string'
                ? parseInt(rawValue.split(' ').join(''), 10)
                : rawValue;

            e.target.value = !_.isNaN(formattedValue)
                ? formattedValue.formatNumber()
                : '';
        };

        const updateModelPrice = (e) => {
            let [minPrice, maxPrice] = $slider.slider('values');
            const minUnfiltered = self.model.get('unfilteredMinPrice');
            const maxUnfiltered = self.model.get('unfilteredMaxPrice');
            const rawValue = e.target.value;

            const currentValue = typeof rawValue === 'string'
                ? parseInt(rawValue.split(' ').join(''), 10)
                : rawValue;

            const minInputValidator = (value) => {
                if (!value || value >= maxPrice || value < minUnfiltered) {
                    return minUnfiltered;
                }

                return value;
            };

            const maxInputValidator = (value) => {
                if (!value || value <= minPrice || value > maxUnfiltered) {
                    return maxUnfiltered;
                }

                return value;
            };

            if (e.target.classList.contains('budget-max')) {
                const validatedValue = maxInputValidator(currentValue);
                e.target.value = validatedValue.formatNumber();
                maxPrice = validatedValue;
            } else if (e.target.classList.contains('budget-min')) {
                const validatedValue = minInputValidator(currentValue);
                e.target.value = validatedValue.formatNumber();
                minPrice = validatedValue;
            }

            $slider.slider('values', [minPrice, maxPrice]);
            self.filters.model.set('minPrice', minPrice);
            self.filters.model.set('maxPrice', maxPrice);
        };

        const $priceFilters = $('.priceRangeFilter-budget__input');

        $priceFilters.each((i, $el) => {
            $($el).on('input', formatterInput);
            $($el).on('blur', updateModelPrice);
        });
    },

	initSubviews:function() {
		this.filters = new FilterCriteriaView({
			model: filterCriteria,
			searchPageModel: this.model,
			searchFormViewModel: this.searchFormViewModel,
			dataLayerAnalytics: this.dataLayerAnalytics,
		});

		new FixFiltersPositionView({
			searchPageModel: this.model
		});


		new MakeSearchStaticBannerView({
			parentView: this
		});

		new FixMapPositionView({
			searchPageModel: this.model
		});

        this.initVueComponents();
	},
	initDomEvents:function() {
		var bottomListElement = $('#eop'),
			self = this;

		$(window).scroll(function() {
			var scrollTopPosition = $(document).scrollTop(),
				windowHeight = $(window).height();

			self.model.set('scrollPosition', scrollTopPosition);

			if(!bottomListElement.length) {
				bottomListElement = $('#eop');
			}

			if(bottomListElement.length && bottomListElement.is(':visible') && scrollTopPosition+windowHeight+320>bottomListElement.position().top) {
				self.pageInc();
			}
		});

		$(document).on('submit', '.thBlockForm', function(e){
			$('.thFormSubmit', $(this).parent()).click();
			e.preventDefault();
			return false;
		});

		$(".formControl.selectHotel").on("click", function () {
			self.model.set("showHotelSearchTooltip", false);
			$.cookie("hotelSearchTooltipWasShoved", true);
		});
		this.beforeCloseInit();
	},
	beforeCloseInit:function() {
		var self = this,
			mouseLeaveCallback = function(e){
				if (e.clientY < 0 && !$('.ui-dialog:visible').length &&	self.model.get('loadingState') == 'finished') {
					if (self.model.get('regionType')  == 'region' && $.cookie('beforeCloseSerpPopupShown') != "true" && !$('#onBeforeClose:visible').length) {

						if(typeof(yaCounter11881159) !== 'undefined') {
							yaCounter11881159.reachGoal('dontleavepopupopen');
						}
						$.cookie('beforeCloseSerpPopupShown', true, { path: '/', expires: 1, domain:'all' });
						$('body').off('mouseleave', mouseLeaveCallback);
					} else if ($.cookie('emailSubscribePopup') !== "true" && document.location.pathname == "/search") {
						$.cookie('emailSubscribePopup', true, { path: '/', expires: 1, domain:'all' });
						$('body').off('mouseleave', mouseLeaveCallback);
					}
				}
			};

		$('body').on('mouseleave', mouseLeaveCallback);
	},
	getModelOptions({ searchFormViewModel }, hotelsCollection, filterCriteria, systemLogInfo) {
		return {
			filterCriteria,
			hotelsCollection,
			searchFormViewModel,
            systemLogInfo,
		}
	},
	initialize: function(options) {
		options = options || {};
        this.systemInfoBenchmark = new SystemInfoBenchmark();

		let ModelConstructor = options && options.SearchPageModel ? options.SearchPageModel : SearchPageModel;

		const constructorParams = this.getModelOptions(options, hotelsCollection, filterCriteria, this.systemInfoBenchmark);

		this.model = new ModelConstructor(constructorParams);
		this.searchFormViewModel = options.searchFormViewModel;

		const hotelView = options?.SearchPageHotelView
			? options.SearchPageHotelView
			: SearchPageHotelView;

		const hotelTemplate = options?.hotelTemplate
			? { hotelTemplate: options.hotelTemplate }
			: {};

		this.itemView = hotelView.extend({ ...hotelTemplate, searchFormViewModel: this.searchFormViewModel });

		this.dataLayerAnalytics = options.dataLayerAnalytics;
		this.withoutStatic = options.withoutStatic;

		this.viewModel = new Backbone.Epoxy.Model({
			filtersUpdating:false
		});
		this.initSlider();
		this.initSubviews();
		this.initSlider();
		this.initDomEvents();
		this.initSubscribes();
		this.initModelEvents();
		this.dataLayerEvents();
	},
	initVueComponents() {
        this.initCountryConditions();
        this.initRefreshLoader();
    },
	initCountryConditions() {
		const store = getStore({
			name: 'mapForCountryConditions',
			backboneMap: [
				{
					fields: [{
						countries: {
							field: 'searchData',
							action: (model, searchData) => searchData?.get('countries')?.pluck('id'),
						},
					}],
					model: this.model,
				},
			],
		});

		new Vue({
			el: '.js-country-conditions',
			render: (h) => h(CountryConditions),
			store,
		});
	},
    initRefreshLoader() {
        const store = getStore({
            name: 'mapForRefreshLoaderWrapper',
            backboneMap: [{
                fields: [{ show: 'filtersUpdating' }],
                model: this.viewModel,
            }],
        });
        this.refreshLoaderWrapperVueComponent = new RefreshLoaderWrapper({
            store,
            propsData: {
                storeModuleName: 'mapForRefreshLoaderWrapper',
                showPropName: 'show',
            },
        }).$mount();
        $('.searchContainer').append(this.refreshLoaderWrapperVueComponent.$el);
    },
    initModelEvents() {
        this.model.on('change:loadingState', (model, value) => {
            if (value === 'finished' && !$.cookie('hotelSearchTooltipWasShoved')) {
                this.model.set('showHotelSearchTooltip', true);
                setTimeout(() => {
                    $.cookie('hotelSearchTooltipWasShoved', true);
                    this.model.set('showHotelSearchTooltip', false);
                }, 3000);
            }
        });

        const filterCriteriaChanged = _.debounce((model, context) => {
            const renderTime = this.systemInfoBenchmark.getResult('serpToursProductsRenderTime');
            console.log(`%c products cards render time: ${renderTime}`, 'background: #222; color: #bada55');
            trackingService.trackSearchFilters({
                filters: this.filters,
                serpProductsRenderTime: renderTime,
                autoChange: context && _.isObject(context) && !_.isEmpty(context),
                filteredHotels: this.model.get('filteredHotels'),
            });
        }, 10);

        this.model.get('filterCriteria').on('change', $.proxy(filterCriteriaChanged, this));
    },
	initSubscribes:function() {
		this.model.on('change:sortStrategy', $.proxy(this.changedSortStrategy, this));

		this.model.on('change:viewMode', $.proxy(this.changedViewMode, this));

		this.listenTo(this.model, 'change:unfilteredMinPrice', function(){
			var $slider = $('#priceRangeSlider'),
				minValue = this.filters.model.get('minPrice'),
				maxValue = this.filters.model.get('maxPrice'),
				unfilteredMinPrice = this.model.get('unfilteredMinPrice'),
				minValueToSet = minValue;

			if(minValueToSet < unfilteredMinPrice) {
				minValueToSet = unfilteredMinPrice;
			}

			$slider.slider({min: unfilteredMinPrice, values: [minValueToSet, maxValue]});
			this.model.set('sliderMinPrice', minValueToSet);
		});

		this.listenTo(this.model, 'change:unfilteredMaxPrice', function(){
			var $slider = $('#priceRangeSlider'),
				minValue = this.filters.model.get('minPrice'),
				maxValue = this.filters.model.get('maxPrice'),
				unfilteredMaxPrice = this.model.get('unfilteredMaxPrice'),
				maxValueToSet = maxValue;

			if(maxValueToSet > unfilteredMaxPrice) {
				maxValueToSet = unfilteredMaxPrice;
			}
			$slider.slider({max: unfilteredMaxPrice, values: [minValue, maxValueToSet]});
			this.model.set('sliderMaxPrice', maxValueToSet);
		});

		this.listenTo(this.filters.model, 'change:minPrice', function(){
			var $slider = $('#priceRangeSlider'),
				values = $slider.slider("values"),
				minValue = this.filters.model.get('minPrice'),
				maxValue = this.filters.model.get('maxPrice'),
				unfilteredMinPrice = this.model.get('unfilteredMinPrice');

			if(minValue < unfilteredMinPrice) {
				minValue = unfilteredMinPrice;
			}

			$slider.slider('values', [minValue, values[1]]);
			this.filters.model.set('minPrice', minValue);
			this.model.set('sliderMinPrice', minValue);
		});

		this.listenTo(this.filters.model, 'change:maxPrice', function(){
			var $slider = $('#priceRangeSlider'),
				values = $slider.slider("values"),
				maxValue = this.filters.model.get('maxPrice'),
				unfilteredMaxPrice = this.model.get('unfilteredMaxPrice');

			if(maxValue > unfilteredMaxPrice) {
				maxValue = unfilteredMaxPrice;
			}

			$slider.slider('values', [values[0], maxValue]);
			this.filters.model.set('maxPrice', maxValue);
			this.model.set('sliderMaxPrice', maxValue);
		});

		this.filters.model.on('change', $.proxy(this.changedFilters, this));


	},
	pageInc: function() {
		if(this.model.get('pageIncAvaliable')) {
			this.model.set('pageNumber', this.model.get('pageNumber')+1);
		}
		return false;
	},
	showAllCheapest:function(event) {
		this.model.set('sortStrategy', 'priceUp');
		this.clearFilter();
		this.showAll();
		return false;
	},
	showAll: function(event) {
		var fullHotels = this.model.get('asyncHotels'),
			fullTourProducts = this.model.get('asyncTourProducts');

		this.model.set('pageNumber', 1, {silent:true});
		this.collection.reset();

		this.model.set('syncHotels', new HotelsRepository(fullHotels.models));
		this.model.set('syncTourProducts', fullTourProducts);

		console.log('Show new async tours click');

		return false;
	},
	nothingFoundFormToggle: function() {
		this.model.set('nothingFoundFormOpened', !this.model.get('nothingFoundFormOpened'));
	},
	searchCriteriaChanged: function() {

	},
	clearFilter:function(options) {
		var currentModel = options.currentModel;
		if(!currentModel.get("countries"))return false;
		var filter = this.model.get('filterCriteria'),
			country = currentModel.get("countries").get("model").at(0),
			departureCityId = currentModel.get('departureCity').get("model").get('id'),
			departureCityType = departureCityId == 1 || departureCityId == 2 ? 'capital' : 'region',
			countryTourCriteria = country.get(departureCityType + 'TourCriteria');

		if(!options.onlyPostfilters) {
			currentModel.get("hotelCategories").set('model', new HotelCategoriesRepository(HotelCategoriesRepository.repository.getById(countryTourCriteria.hotelCategories)), {
				initiator:'clearFilter'
			});
			currentModel.get("meals").set('model', new MealsRepository(MealsRepository.repository.getById(countryTourCriteria.meals)), {
				initiator:'clearFilter'
			});
		}

		filter.set({
			withKids:false,
			adultsOnly:false,
			forCouples:false,
			nearTheLift:false,
			nearTheBeach: false,
			firstLine:false,
			secondLine:false,
			thirdLine:false,
			beachOwner:false,
			nearTheCenter:false,
            lonelyMan: false,
            cashback: false,
			airConditioner:false,
			wellness:false,
			pool:false,
			animation:false,
			familyRooms:false,
			diving:false,
			freeSafe:false,
			fitnessCenter:false,
			freeMiniBar:false,
			skiEquipment:false,
			honeyMoon:false,
			waterSports:false,
			spaAndHealth:false,
			nightClub:false,
			personsWithDisabilities:false,
			noSmokingRooms:false,
			smokingRooms:false,
			children_animators: false,
			children_pool: false,
			children_waterslides: false,
			children_aquapark: false,
			children_seaEnter: false,
			children_childmenu: false,
			children_childBed: false,
			children_nanny: false,
			children_clubs: false,
			beachType: 0,
			minPrice: 6000,
			maxPrice: 10000000,
			wifi:false,
			best:false,
			better:false,
			good:false,
			satisfactorily:false,
			noScore:false,
			operators:[],
			openPool: false,
			closePool: false,
			heatedPool: false,
			seaPool: false,
			kidsPool: false,
			waterslides: false,
			aquapark: false,
			saunaBathHammam: false,
			jacuzzi: false,
			freeCancellation: false
		}, {
			initiator:'clearFilter'
		});
		return false;
	},
	scrollToTours: function() {
		var element = $('.searchContainer_navbar'),
			currenPosition = $(document).scrollTop(),
			headerHeight = 176,//$('.headerContainer').height(),
			menuHeight = $('.menuContainer').height(),
			scrollHotellistPosition;

		if(element.length) {
			scrollHotellistPosition = $(element).offset().top;

			headerHeight ? scrollHotellistPosition -= headerHeight : '';
			menuHeight ? scrollHotellistPosition -= menuHeight : '';

			scrollHotellistPosition -= 10;

			if (currenPosition > scrollHotellistPosition) {
				$("html,body").stop(true, false).animate({scrollTop: scrollHotellistPosition}, 700);
			}
		}
	},
	scrollToTop: function() {
		var currenPosition = $(document).scrollTop();
			//scrollHotellistPosition = $('.mainColumnRight').offset().top;

		if (currenPosition>0) {
			$("html,body").stop(true, false).animate({scrollTop: 0}, 700);
		}
	},
	changedFilters:function() {
		var self = this;

		clearTimeout(this.filtersUpdateTimeout);
		this.viewModel.set('filtersUpdating', true);

		this.filtersUpdateTimeout = setTimeout(function() {
			self.viewModel.set('filtersUpdating', false);
		}, 1000);
	},
	changedSortStrategy: function(model, sortDirection) {
		var filteredHotels = this.model.get('filteredHotels'),
			filteredSimilarHotels = this.model.get('filteredSimilarHotels');

		switch (sortDirection) {
			case "recommend":
				gaAsync(function(){ga('send', 'event', 'Sorting', 'Recommended', 'a-z', {'nonInteraction': 1})});
				break;
			case "priceUp":
				gaAsync(function(){ga('send', 'event', 'Sorting', 'Price', 'a-z', {'nonInteraction': 1})});
				break;
			case "priceDown":
				gaAsync(function(){ga('send', 'event', 'Sorting', 'Price', 'z-a', {'nonInteraction': 1})});
				break;
			case "ratingDown":
				gaAsync(function(){ga('send', 'event', 'Sorting', 'Guest_Rating', 'z-a', {'nonInteraction': 1})});
				break;
			case "reviewsDown":
				gaAsync(function(){ga('send', 'event', 'Sorting', 'Guest_ReviewsCount', 'z-a', {'nonInteraction': 1})});
				break;
		}

		this.model.set('sortStrategyChanged', true);
		if(filteredHotels.length) {
			this.model.set('pageNumber', 1, {silent:true});
			this.collection.reset();
			this.model.get('filteredHotels').sort();
			this.model.trigger('change:filteredHotels');
		} else if (filteredSimilarHotels.length){
			filteredSimilarHotels.sort();
			this.model.trigger('change:filteredSimilarHotels');
		}
		this.model.set('sortStrategyChanged', false);

		console.log('changed SortStrategy to:' + sortDirection);
	},
	changedViewMode: async function(model, viewMode) {
		switch (viewMode) {
			case "compact":
				gaAsync(function(){ga('send', 'event', 'Sorting', 'View1', 'blocks', {'nonInteraction': 1})});
				break;
			case "standart":
				gaAsync(function(){ga('send', 'event', 'Sorting', 'View2', 'list', {'nonInteraction': 1})});
				break;
			case "map":
				gaAsync(function(){ga('send', 'event', 'Sorting', 'View3', 'map', {'nonInteraction': 1})});
				break;
		}

		let SearchPageHotelViewExtend = SearchPageHotelView.extend({
			searchFormViewModel:this.searchFormViewModel
		});

        if (viewMode == 'map' && !this.hotelsMap) {
            let { default: HotelsMapView } = await import(/* webpackChunkName: "HotelsMapView" */ '@/js/desktop/components/hotelsMap/HotelsMap');

            const hotelOnMapView = new HotelOnMapView();

            this.hotelsMap = new HotelsMapView({
                hotelMapView: hotelOnMapView,
                searchPageModel: this.model,
                HotelsList: SearchPageHotelViewExtend,
            });
		} else {
			setTimeout(function() {
				$('.js-images-carousel').jcarousel('reload', {
					animation: 'fast'
				});
			}, 1);
		}

		this.scrollToTours();
		console.log('changed viewMode to:' + viewMode);
	},
	dataLayerEvents(){
		if(this.dataLayerAnalytics){
			//fixed
			this.dataLayerAnalytics.generateEvent("cacheResults", !this.withoutStatic);
			this.dataLayerAnalytics.preSearchPagePath();
		}
	},
});

export default SearchPageView;
